// Module
var code = `<div class="svc-item-value-wrapper" data-bind="event: { pointerdown: function (model, event) { onPointerDown(event); return true; } },attr: attributes, css: { 'svc-item-value--new': isNew, 'svc-item-value--dragging': isDragging, 'svc-item-value--ghost': isDragDropGhost, 'svc-item-value--movedown':isDragDropMoveDown, 'svc-item-value--moveup':isDragDropMoveUp }">
  <div class="svc-item-value__ghost"></div>
  <div class="svc-item-value-controls">
    <!-- ko if: isDraggable -->
    <span class="svc-item-value-controls__button svc-item-value-controls__drag">
      <sv-svg-icon class="svc-item-value-controls__drag-icon" params="iconName: 'icon-drag-24x24', size: 'auto', title: dragTooltip"></sv-svg-icon>
    </span>
    <!-- /ko -->
    <!-- ko if: allowAdd -->
    <sv-svg-icon class="svc-item-value-controls__button svc-item-value-controls__add" data-bind="click: add, key2click, attr: { 'aria-label': tooltip }" params="iconName: 'icon-add_16x16', size: 'auto', title: tooltip">
    </sv-svg-icon>
    <!-- /ko -->
    <!-- ko if: allowRemove -->
    <sv-svg-icon class="svc-item-value-controls__button svc-item-value-controls__remove" data-bind="click: remove, key2click, attr: { 'aria-label': tooltip }, event: { blur: koOnFocusOut }" params="iconName: 'icon-remove_16x16', size: 'auto', title: tooltip">
    </sv-svg-icon>
    <!-- /ko -->
  </div>

  <div class="svc-item-value__item" data-bind="click: select">
    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;